import OliverText from "@builder/components/general/OliverText";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ActionType } from "@common/build/types";
import { useEffect } from "react";
import SimpleCheckbox from "@builder/components/general/SimpleCheckbox";

const TapToPayAction = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const dispatch = useAppDispatch();

    // const handleAmount = (value: string, key: "addedFee" | "addedDiscount") => {
    //     updateNodeProperty([key, "value"], value);
    // };

    // const handleToggle = (key: "addedFee" | "addedDiscount") => {
    //     setPaymentDetails((prevDetails: any) => {
    //         const updatedDetails = { ...prevDetails };
    //         const updatedKey = { ...updatedDetails[key] };

    //         updatedKey.type = updatedKey.type === "$" ? "%" : "$";

    //         updatedDetails[key] = updatedKey;

    //         return updatedDetails;
    //     });
    // };

    useEffect(() => {
        const action = {
            type: ActionType.TAP_TO_PAY
        };

        const updatedStep = { ...actionStep };
        updatedStep.action = { ...action };

        if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
            dispatch(updateStepperActions({ id: id as string, item: updatedStep as ActionEditorItem }));
        }
    }, [actionStep, dispatch, id]);

    return (
        <div className="function-add-cart-note-wrapper">
            <div className="function-add-cart-note">
                {/* <div className="function-add-cart-note-wrapper">
                    <TextInput
                        title="Add fee"
                        callback={value => handleAmount(value, "addedFee")}
                        value={paymentDetails.addedFee?.value || ""}
                        className="actions-tab-input"
                        placeholder="Amount"
                        icon={{
                            src: ["./dollar-sign.svg", "./percentage-sign.svg"],
                            callback: (event: React.MouseEvent) => {
                                event.preventDefault();
                                handleToggle("addedFee");
                            }
                        }}
                        isPercent={paymentDetails.addedFee?.type === "%"}
                    />
                    <TextInput
                        title="Add discount"
                        callback={value => handleAmount(value, "addedDiscount")}
                        value={paymentDetails.addedDiscount?.value || ""}
                        className="actions-tab-input"
                        placeholder="Amount"
                        icon={{
                            src: ["./dollar-sign.svg", "./percentage-sign.svg"],
                            callback: (event: React.MouseEvent) => {
                                event.preventDefault();
                                handleToggle("addedDiscount");
                            }
                        }}
                        isPercent={paymentDetails.addedDiscount?.type === "%"}
                    />
                </div> */}

                <div className="function-checkbox-wrapper">
                    <div className="function-checkbox-label-wrapper">
                        <OliverText text="Tap to pay" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                        <OliverText
                            text="This will process the payment using tap to pay functionality"
                            size="xs"
                            weight="light"
                            translatePrefix="popup.actionBuilder."
                        />
                    </div>
                    <SimpleCheckbox callback={() => { }} checked={true} label="" value="" custom={false} />
                </div>
            </div>
        </div>
    );
};

export default TapToPayAction;
